//暴露常量
export const SET_USERINFO='SET_USERINFO';
export const SET_TOKEN='SET_TOKEN';
export const SET_REGPARAMS='SET_REGPARAMS';
